import {
  SUPPORT_ALL,
  SUPPORT_ALL_SUCCESS,
  SUPPORT_COMMENT,
  SUPPORT_COMMENT_SUCCESS,
  SUPPORT_CREATE,
  SUPPORT_CREATE_SUCCESS,
  SUPPORT_GET,
  SUPPORT_GET_SUCCESS,
} from '../constants/Support';

const initialState = {
	ticket: {
		id: null,
		name: '',
		color: '',
	},
	tickets: null,
	loading: false,
	perPage: 0,
	page: 0,
	total: 0,
};

const support = (state = initialState, action) => {
	switch (action.type) {
		case SUPPORT_ALL:
			return {
				...state,
				perPage: action.perPage,
				page: action.page,
				loading: true,
			};
		case SUPPORT_ALL_SUCCESS:
			return {
				...state,
				tickets: action.tickets,
				total: action.total,
				loading: false,
			};
		case SUPPORT_GET:
			return {
				...state,
				loading: true,
			};
		case SUPPORT_GET_SUCCESS:
			return {
				...state,
				ticket: action.ticket,
				loading: false,
			};
		case SUPPORT_CREATE:
			return {
				...state,
				loading: true,
			};
		case SUPPORT_CREATE_SUCCESS:
			return {
				...state,
				tickets: [...state.tickets, action.ticket],
				loading: false,
			};
		case SUPPORT_COMMENT:
			return {
				...state,
				loading: true,
			};
		case SUPPORT_COMMENT_SUCCESS:
			return {
				...state,
				loading: false,
			};
		default:
			return state;
	}
};

export default support;
